import React from 'react';
import { useParams } from 'react-router-dom';
import { useCampaignDetailModel } from './model';
import { CampaignDetailView } from './view';

export const CampaignDetailWidget: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const {
    state,
    templates,
    selectedBinding,
    openForward,
    closeForward,
    handleForwardSubmitted,
    selectBinding,
    cancelSendBatch,
  } = useCampaignDetailModel(id);

  return (
    <CampaignDetailView
      state={state}
      templates={templates}
      selectedBinding={selectedBinding}
      onForward={openForward}
      onCloseForward={closeForward}
      onForwardSubmitted={handleForwardSubmitted}
      onSelectBinding={selectBinding}
      onCancelSendBatch={cancelSendBatch}
    />
  );
};
